import React from 'react';
import { inr, pct } from './format';

const CARDS = [
  ['total_pos', 'Total Purchase Orders', 'count', 'border-l-slate-800'],
  ['total_grns', 'Total GRNs', 'count', 'border-l-slate-800'],
  ['total_po_value', 'Total PO Value (Incl. GST)', 'money', 'border-l-indigo-500'],
  ['total_grn_received_value', 'Total GRN Received Value', 'money', 'border-l-indigo-500'],
  ['total_accepted_value', 'Total Accepted Value', 'money', 'border-l-emerald-500'],
  ['pending_po_value', 'Pending PO Value', 'money', 'border-l-amber-500'],
  ['total_ppv', 'Total Purchase Price Variance', 'money', 'border-l-rose-500'],
  ['pos_fully_received', 'POs Fully Received', 'count', 'border-l-emerald-500'],
  ['pos_partially_received', 'POs Partially Received', 'count', 'border-l-amber-500'],
  ['pos_not_received', 'POs Not Yet Received', 'count', 'border-l-rose-500'],
  ['open_exceptions', 'Open Exceptions', 'count', 'border-l-rose-500'],
  ['inward_margin_pct', 'Inward Margin %', 'pct', 'border-l-sky-500'],
  ['inward_margin_value', 'Inward Margin Value', 'money', 'border-l-sky-500'],
  ['outward_margin_pct', 'Outward Margin %', 'pct', 'border-l-violet-500'],
  ['outward_margin_value', 'Outward Margin Value', 'money', 'border-l-violet-500'],
  ['current_margin_pct', 'Current Margin %', 'pct', 'border-l-emerald-600'],
  ['current_margin_value', 'Current Margin Value', 'money', 'border-l-emerald-600'],
];

const FORMULA = {
  inward_margin_pct: 'Σ (GRN MRP − GRN Price) × Qty ÷ Σ (GRN MRP × Qty) × 100',
  inward_margin_value: 'Σ (GRN MRP − GRN Price) × Accepted Qty',
  outward_margin_pct: 'Σ (GRN MRP − Selling Price) × Qty ÷ Σ (GRN MRP × Qty) × 100',
  outward_margin_value: 'Σ (GRN MRP − Selling Price) × Accepted Qty',
  current_margin_pct: 'Σ (Selling Price − GRN Price) × Qty ÷ Σ (Selling Price × Qty) × 100',
  current_margin_value: 'Σ (Selling Price − GRN Price) × Accepted Qty',
};

const show = (v, type) => {
  if (type === 'money') return inr(v);
  if (type === 'pct') return pct(v);
  return Number(v || 0).toLocaleString('en-IN');
};

export const KpiGrid = ({ kpis }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3" data-testid="po-grn-kpis">
    {CARDS.map(([key, label, type, accent], i) => (
      <div key={key}
        className={`rounded-lg border border-slate-200 border-l-4 ${accent} bg-white px-4 py-3 animate-in fade-in slide-in-from-bottom-1`}
        style={{ animationDelay: `${i * 30}ms`, animationFillMode: 'both' }}
        data-testid={`kpi-${key}`}>
        <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500 leading-tight">{label}</div>
        <div className={`mt-1.5 text-xl font-bold tabular-nums ${(key === 'total_ppv' && kpis?.[key] > 0) || (key.includes('margin') && kpis?.[key] < 0) ? 'text-rose-600' : 'text-slate-900'}`} data-testid={`kpi-${key}-value`}>
          {kpis ? show(kpis[key], type) : '—'}
        </div>
        {FORMULA[key] && <div className="text-[10px] text-slate-500 mt-1 leading-snug" data-testid={`kpi-${key}-formula`}>{FORMULA[key]}</div>}
      </div>
    ))}
  </div>
);
